<template>
    <div class="template template--sidebar">
        <achievement></achievement>

        <sidebar-workspace :user="loggedInUser" :group="currentGroup" :loadingUserProgress="false"></sidebar-workspace>

        <div class="page-wrap">
            <transition name="view-transition" mode="out-in" @after-leave="afterPageViewLeave">
                <router-view class="page-view" :key="viewKey" :loading="false" :user="loggedInUser" :group="currentGroup"></router-view>
            </transition>
        </div>

    </div>
</template>


<script>

import SidebarWorkspace from 'js/components/sidebar/SidebarWorkspace.vue'
import Achievement from 'js/components/elements/Achievement.vue';

import { canTeach } from 'js/api/auth'
import { getGroupIdForCurrentUser, getGroup } from 'js/vuex/getters'

export default {
    name: 'WorkspaceManager',
    components: { SidebarWorkspace, Achievement },

    vuex: {
        getters: {
            getGroupIdForCurrentUser,
            getGroup,
        },
        actions: {
            showGroupArchivedModal: ({ dispatch }, user ) => {
                dispatch('SHOW_MODAL', 'GroupArchived', { user: user })
            },
        },
    },

    computed: {
        viewKey: function() {

            let key = this.$route.name.split('.').slice(0,2).join('.')

            if ( this.$route.params.periodId !=  null ) key += '-period-' + this.$route.params.periodId
            if ( this.$route.params.assignmentId !=  null ) key += '-assignment-' + this.$route.params.assignmentId

            return key
        },

        currentGroup: function() {
            const currentGroupId = this.$route.params.groupId == null ? this.getGroupIdForCurrentUser : this.$route.params.groupId
            return this.getGroup( currentGroupId )
        },

        loggedInUser: function() {
            return this.$store.state.users.current
        },

    },

    methods: {
        afterPageViewLeave: function () {
            document.getElementById('main-view').scrollTop = 0
        },
    },

    created: function() {

        if ( canTeach(this.loggedInUser) ) {
            this.$router.replace({ name: 'root' })
            return
        }

        if ( this.currentGroup.archived ) {
            this.showGroupArchivedModal(this.loggedInUser)
        }
    },

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// WorkspaceManager.vue?685195da